import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const patchPlacement = ({ accountId, position, name, placementId }) => {
  const placementAttributes = {
    data: {
      type: 'placement',
      id: placementId,
      attributes: {
        position,
        name,
      },
    },
  }

  return HttpClient().patch(
    `/moments/accounts/${accountId}/placements/${placementId}`,
    placementAttributes
  )
}

const updatePlacement = (options) => (dispatch) =>
  patchPlacement(options)
    .then((response) => {
      const body = response.data
      if (body.data) dispatch(loadJsonApiEntities(body))

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default updatePlacement
